import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle, Loader2 } from 'lucide-react';
import api from '../utils/axiosConfig';

const CoachingSuccess = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [verifying, setVerifying] = useState(!!sessionId);
  const [verifyError, setVerifyError] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setVerifying(false);
      return;
    }
    api
      .post('/api/stripe/verify-session', { sessionId })
      .then(() => {
        window.dispatchEvent(new Event('planSubscriptionUpdated'));
      })
      .catch((err) => {
        setVerifyError(err.response?.data?.error || err.message);
      })
      .finally(() => setVerifying(false));
  }, [sessionId]);

  return (
    <div className='max-w-md mx-auto p-6'>
      <Card>
        <CardHeader>
          <CardTitle className='flex items-center gap-2 text-green-600 dark:text-green-500'>
            {verifying ? (
              <Loader2 className='h-6 w-6 animate-spin' />
            ) : (
              <CheckCircle className='h-6 w-6' />
            )}
            {verifying ? t('coaches.verifying') : t('coaches.subscribeSuccessTitle')}
          </CardTitle>
        </CardHeader>
        <CardContent className='space-y-4'>
          {!verifying && !verifyError && (
            <p className='text-sm text-muted-foreground'>{t('coaches.subscribeSuccessBody')}</p>
          )}
          {verifyError && (
            <p className='text-sm text-destructive' role='alert'>
              {verifyError}
            </p>
          )}
          <div className='flex flex-col gap-2'>
            <Button asChild>
              <Link to='/dashboard'>{t('checkout.backToDashboard')}</Link>
            </Button>
            <Button variant='outline' asChild>
              <Link to='/coaches'>{t('coaches.backToCatalog')}</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CoachingSuccess;
